import { render, staticRenderFns } from "./ContentFormGiayChuyenTuyen.vue?vue&type=template&id=0dc832c9&scoped=true"
import script from "./ContentFormGiayChuyenTuyen.vue?vue&type=script&lang=js"
export * from "./ContentFormGiayChuyenTuyen.vue?vue&type=script&lang=js"
import style0 from "./ContentFormGiayChuyenTuyen.vue?vue&type=style&index=0&id=0dc832c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc832c9",
  null
  
)

export default component.exports